<template>
  <div class="detail" v-if="showPage">
    <!-- 面包屑 -->
    <breadcrumb></breadcrumb>
    <!-- <header-crunb :crumbList="crumbList"></header-crunb> -->
    <!-- 封面简介 -->
    <div class="card-detail">
      <el-row>
        <el-col :span="11">
          <div class="img-box">
            <el-image
              fit="cover"
              class="fm-img"
              :src="
                activeInfo.faceAttaches
                  ? activeInfo.faceAttaches[0].attachUrl
                  : ''
              "
              alt
            ></el-image>
            <!-- <img :src="activeInfo.faceAttaches ? activeInfo.faceAttaches[0].attachUrl :''" alt /> -->
            <div class="state">
              <span>{{
                resOptions.stateList.find(
                  (i) => i.value === activeInfo.activeStatus
                ).name
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="ms">
            <h2>{{ activeInfo.actTitle }}</h2>
            <h5>
              <span class="bg-btn">{{ activeInfo.getClassify3Desc }}</span>
            </h5>

            <h3 class="one-txt-cut">
              {{ activeInfo.startDate }}～ {{ activeInfo.endDate }}
            </h3>
            <h3 class="one-txt-cut">
              <i class="el-icon-location"></i>
              <span>培训地点</span>
              {{ activeInfo.createSchool + activeInfo.address }}
            </h3>
            <h3 class="one-txt-cut">
              <i class="el-icon-s-home"></i>
              <span>年级</span>
              <em v-for="i in activeInfo.grades" :key="i.id"
                >{{ i.gradeName }} &nbsp;&nbsp;</em
              >
            </h3>
            <h3 class="one-txt-cut">
              <i class="el-icon-s-order"></i>
              <span>学科</span>
              <em v-for="i in activeInfo.disciplines" :key="i.id"
                >{{ i.disciplineName }}&nbsp;&nbsp;</em
              >
            </h3>
            <h3>
              <i class="el-icon-s-custom"></i>
              <span>主持人</span>
              <img
                :src="
                  activeInfo.createLogo ? activeInfo.createLogo : defaultManPng
                "
                alt
              />
              <span>{{ activeInfo.createName }}</span>
              <span>{{ activeInfo.createSchool }}</span>
            </h3>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="qr-code">
            <div class="qrcode" ref="myCodeUrl"></div>
            <h5>签到码：{{ activeInfo.qrCode }}</h5>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 主题内容 -->
    <div>
      <!-- 切换 -->
      <div class="tab-tpl-detail">
        <span
          @click="changeType(i.code)"
          :class="activeCode === i.code ? 'active' : ''"
          v-for="i in typeList"
          :key="i.code"
          >{{ i.name }}</span
        >
      </div>

      <div id="scroll-content" class="clearfix">
        <!-- 描述 -->
        <div id="href-detail">
          <tpl-detail titName="活动描述">
            <template slot="body">
              <!-- 活动目标或内容：  -->
              <p class="act-content">{{ activeInfo.actContent }}</p>
              <!-- 活动安排： -->
              <p class="act-content">{{ activeInfo.actPlan }}</p>
            </template>
          </tpl-detail>
        </div>
        <!-- 活动环节 -->
        <div id="href-link"
        v-if="linkInfo.length > 0"
        >
          <tpl-detail titName="活动环节">
            <template slot="body">
              <ul>
                <li
                  class="clearfix"
                  v-for="(i, index) in linkInfo"
                  :key="i.id"
                  @click="toPathLink(i.nodeCode)"
                >
                  <span class="fl">{{ index + 1 }}</span>
                  <div class="fl">
                    <h1>{{ i.topic }}</h1>
                    <h2>
                      <i :class="mapLinkIcon(i.nodeType)"></i>
                      {{ i.nodeTypeDesc }}
                    </h2>
                  </div>
                </li>
              </ul>
            </template>
          </tpl-detail>
        </div>
        <div id="href-result">
          <tpl-detail titName="活动成果">
            <template slot="titRight">
              <upload-link
                ref="upResult"
                v-if="activeInfo.activeStatus != 0"
                :showFileList="true"
                accept="*"
                :fileLimit="10"
                @changeUpload="(fileList) => successUpload(fileList, 'result')"
              >
                <template slot="body">
                  <el-button
                    type="primary"
                    size="small"
                    :loading="resultBtnLoading"
                    >上传成果</el-button
                  >
                </template>
              </upload-link>
            </template>
            <template slot="body">
              <ul v-loading="resultLoading">
                <li class="clearfix" v-for="i in resultList" :key="i.id">
                  <i class="fl big-icon" :class="mapFileIcon(i.attachType)"></i>
                  <div class="fl">
                    <h1>
                      {{
                        i.attachName ||
                        i.attachUrl.substring(
                          i.attachUrl.lastIndexOf("\/") + 1,
                          i.attachUrl.length
                        )
                      }}
                    </h1>
                    <h2>{{ i.attachSize }}kb</h2>
                  </div>
                  <el-divider
                    class="fl divider"
                    direction="vertical"
                  ></el-divider>
                  <div class="fl">
                    <h1>{{ i.createName }} {{ i.schoolName }}</h1>
                    <h2>{{ i.createTime }}上传</h2>
                  </div>
                  <el-button
                    type="text"
                    class="dow fr"
                    @click="
                      downloadFile(
                        i.attachUrl,
                        i.attachUrl.substring(
                          i.attachUrl.lastIndexOf('\/') + 1,
                          i.attachUrl.length
                        )
                      )
                    "
                    >下载</el-button
                  >
                  <el-button
                    type="text"
                    class="del fr"
                    v-if="
                      i.id &&
                      (power(userInfo.menuInfoList, 'train-delResult') ||
                        userInfo.userId == i.createBy)
                    "
                    @click="delAttach(i.id, 'result')"
                    >移除</el-button
                  >
                  <el-button
                    type="text"
                    class="look fr"
                    @click="lookFile(i.attachUrl)"
                    >查看</el-button
                  >
                </li>
              </ul>
            </template>
          </tpl-detail>
        </div>
        <div id="href-sucai">
          <tpl-detail titName="活动图片">
            <template slot="titRight">
              <upload-link
                v-if="activeInfo.activeStatus != 0"
                ref="upMaterial"
                :showFileList="true"
                :fileLimit="10"
                accept=".png, .jpg, .jpeg, .mp4"
                @changeUpload="
                  (fileList) => successUpload(fileList, 'material')
                "
              >
                <template slot="body">
                  <el-button
                    type="primary"
                    size="small"
                    :loading="materialBtnLoading"
                    >上传素材</el-button
                  >
                </template>
              </upload-link>
            </template>
            <template slot="body">
              <div class="big-sucai clearfix" v-loading="materialLoading">
                <div class="sucai-box fl" v-for="i in materialList" :key="i.id">
                  <el-image
                    v-if="
                      ['jpg', 'png', 'jpeg', 'image'].includes(i.attachType) ||
                      i.attachType.includes('image')
                    "
                    style="width: 100%; height: 148px"
                    fit="fill"
                    :src="i.attachUrl + '?imageView2/2/h/148'"
                    :preview-src-list="[i.attachUrl]"
                  ></el-image>
                  <video
                    v-else
                    style="width: 100%; height: 148px"
                    controls="controls"
                    :src="i.attachUrl"
                  ></video>
                  <el-button
                    v-if="
                      i.id &&
                      (power(userInfo.menuInfoList, 'train-delResult') ||
                        userInfo.userId == i.createBy)
                    "
                    class="del-sc"
                    icon="el-icon-delete"
                    @click="delAttach(i.id, 'material')"
                  ></el-button>
                  <h1>{{ i.createName }}</h1>
                  <h2>{{ i.createTime }} 上传</h2>
                </div>
              </div>
              <pagination
                v-if="pageObj.total > pageObj.size"
                :pageObj="pageObj"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange"
              >
              </pagination>
            </template>
          </tpl-detail>
        </div>
      </div>
    </div>
    <!-- 删除的对话框 -->
    <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
  </div>
</template>

<script>
import PopupDel from "@/components/PopupDel.vue";
import UploadLink from "@/components/upload/UploadLink.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import TplDetail from "@/templates/TplDetail.vue";
import QRCode from "qrcodejs2";
import {
  mapFileIcon,
  mapLinkIcon,
  lookFile,
  downloadUrlFile,
  power,
} from "@/utils/index.js";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
import Pagination from "@/components/Pagination.vue";
export default {
  components: {
    Breadcrumb,
    TplDetail,
    UploadLink,
    PopupDel,
    Pagination,
  },
  computed: {
    ...mapState(["userInfo", "resOptions", "schoolList"]),
  },
  data() {
    return {
      showPage: false,
      activeInfo: null,
      linkInfo: "",
      defaultManPng: require("@/assets/image/other/man_teacher.png"),
      qrCodeUrl:
        "https://img1.baidu.com/it/u=2877499757,3239316825&fm=224&fmt=auto&gp=0.jpg",

      //滚动
      activeCode: "xq",
      typeList: [
        { code: "xq", name: "活动详情" },
        { code: "cg", name: "活动成果" },
        { code: "sc", name: "活动图片" },
        { code: "qd", name: "活动签到" },
        { code: "tj", name: "活动统计" },
      ],

      //素材 成果
      resultList: [],
      resultLoading: false,
      resultBtnLoading: false,
      materialList: [],
      materialLoading: false,
      materialBtnLoading: false,
      formUpload: {
        actCode: "",
        attachVOList: [
          {
            attachSize: "",
            attachType: "",
            attachUrl: "",
          },
        ],
        classify: "", //活动成果:result,活动图片:material
        operatorId: "",
      },
      delVisible: false,
      attachType: "",
      attachId: "",
      pageObj: {
        current: 1,
        total: 0,
        size: 16,
        pages: 0,
        sizeList: [8, 16, 24, 32],
      },
    };
  },
  async created() {
    await this.init();
    this.getResult();
    this.getMaterial();
  },
  methods: {
    mapFileIcon,
    mapLinkIcon,
    lookFile,
    power,
    creatQrCode() {
      new QRCode(this.$refs.myCodeUrl, {
        text: this.activeInfo.qrCode,
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    handelPower() {
      if (!power(this.userInfo.menuInfoList, "train-signInDeatil")) {
        this.typeList = this.typeList.filter(
          (i) => !["qd", "tj"].includes(i.code)
        );
      } else {
        if (
          this.userInfo.userId != this.activeInfo.createBy &&
          !this.userInfo.roleCodes.includes("admin")
        ) {
          this.typeList = this.typeList.filter((f) => {
            return f.code != "tj" && f.code != "qd";
          });
        }
      }
    },
    downloadFile(url, name) {
      //确认下载完成 后 进行下载记录保存
      downloadUrlFile(url, name);
      //保存下载记录
      // postJson("/operator/saveDownloadInfo", {
      // 	infoCode: sessionStorage.getItem("actCode"),
      // 	module: "training",
      // 	operatorId: this.userInfo.userId,
      // 	schoolCode: this.userInfo.schoolCode
      // });
    },
    async init() {
      this.showPage = false;
      if (sessionStorage.getItem("actCode")) {
        this.activeInfo = await getData("/training/getActiveInfo", {
          actCode: sessionStorage.getItem("actCode"),
          operatorId: this.userInfo.userId,
        });
        sessionStorage.setItem("startDate", this.activeInfo.startDate);
        this.handelPower();
        this.linkInfo = await getData("/training/getActiveNodeTopicList", {
          actCode: sessionStorage.getItem("actCode"),
          isSub: 0, //是否是子活动节点，0：否，1：是     只有项目课题研究是1
        });
      }
      this.showPage = true;
      this.$nextTick(() => {
        this.creatQrCode();
      });
    },
    getResult() {
      this.resultLoading = true;
      getData("/training/getActiveResults", {
        actCode: sessionStorage.getItem("actCode"),
        operatorId: this.userInfo.userId,
        isAttachVisible: this.activeInfo.isAttachVisible,
        isAttachOpen: this.activeInfo.isAttachOpen,
      }).then((data) => {
        this.resultList = data;
        this.resultLoading = false;
      });
    },
    getMaterial(bool) {
      if (bool && this.materialList.length == 1) {
        this.pageObj.current = 1;
      }

      this.materialLoading = true;
      getData("/training/getActiveMaterial", {
        actCode: sessionStorage.getItem("actCode"),
        operatorId: this.userInfo.userId,
        isAttachVisible: this.activeInfo.isAttachVisible,
        isAttachOpen: this.activeInfo.isAttachOpen,
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
      }).then((data) => {
        this.pageObj.total = data.total;
        this.pageObj.pages = data.pages;
        this.materialList = data.records;
        this.materialLoading = false;
      });
    },
    goHref(targetDom) {
      var VueScrollTo = require("vue-scrollto");
      var options = {
        container: "#scroll-content", //滚动的容器
        easing: "ease-in",
        lazy: false,
        offset: -10,
        force: true,
        cancelable: true,
        x: false,
        y: true,
      };
      this.$nextTick(() => {
        //滚动的目标  时间
        VueScrollTo.scrollTo(targetDom, 500, options);
      });
    },
    changeType(code) {
      this.activeCode = code;
      if (code == "xq") {
        this.goHref("#href-detail");
      } else if (code == "cg") {
        this.goHref("#href-result");
      } else if (code == "sc") {
        this.goHref("#href-sucai");
      } else if (code == "qd") {
        this.$router.push({ name: "signInTrain", query: { type: "training" } });
      } else if (code == "tj") {
        this.$router.push({ name: "statisticsTrain" });
      }
    },
    toPathLink(nodeCode) {
      //moduleType: "" //eduResearch 教研活动 	train 培训  topicResearch 项目课题研究
      this.$router.push({
        name: "linkTrain",
        query: { nodeCode: nodeCode, moduleType: "train" },
      });
    },
    async successUpload(fileList, type) {
      try {
        if (type == "result") {
          this.resultBtnLoading = true;
        } else if ((type = "material")) {
          this.materialBtnLoading = true;
        }
        this.formUpload.actCode = sessionStorage.getItem("actCode");
        this.formUpload.operatorId = this.userInfo.userId;
        this.formUpload.classify = type; //活动成果:result,活动图片:material
        this.formUpload.attachVOList = fileList;
        await postJson("/training/saveActiveInfoAttach", this.formUpload);
        this.$refs.upMaterial.clearFiles(); //清空fileList
        this.$refs.upResult.clearFiles();
        this.resultBtnLoading = false;
        this.materialBtnLoading = false;
        if (type == "result") {
          this.getResult();
        } else if ((type = "material")) {
          this.getMaterial();
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    delAttach(id, type) {
      this.attachId = id;
      this.attachType = type;
      this.delVisible = true;
    },
    // 删除弹框 关闭
    async closePopupDel(status) {
      try {
        if (status) {
          await postData("/training/deleteActiveInfoAttach", {
            id: this.attachId,
          });
          this.$message({
            message: "删除成功",
            type: "success",
            duration: 2000,
            offset: 150,
          });
          this.delVisible = false;
          if (this.attachType == "result") {
            this.getResult();
          } else if ((this.attachType = "material")) {
            this.getMaterial(true);
          }
        } else {
          this.delVisible = false;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    //分页
    handleSizeChange(pageSize) {
      this.pageObj.current = 1;
      this.pageObj.size = pageSize;
      this.getMaterial();
    },
    handleCurrentChange(curPage) {
      this.pageObj.current = curPage;
      this.getMaterial();
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.detail {
  // padding: 10px 20px;
  // border: 1px solid #000;
  //头
  .card-detail {
    margin-top: 15px;
    // padding: 10px 20px;
    background-color: #fff;

    // border-radius: 10px;
    .img-box {
      height: 260px;
      position: relative;
      top: 0px;
      left: 0px;

      .fm-img {
        height: 100%;
        width: 100%;
      }

      img {
        height: 100%;
        width: 100%;
      }

      .state {
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 40px;
        background: @hui;

        span {
          padding: 4px 7px;
          background: @color;
          line-height: 40px;
          margin-left: 7%;
          border-radius: 4px;
          color: rgb(238, 232, 232);
        }
      }
    }

    .ms {
      padding-left: 20px;
      padding-top: 6px;
      font-size: 14px;
      color: #000;

      h2 {
        font-size: 18px;
        height: 47px;
        line-height: 55px;
        font-weight: 550;
        // border: 1px solid #000;
      }

      h5 {
        height: 30px;
        line-height: 22px;

        // border: 1px solid #000;
        .bg-btn {
          padding: 4px 7px;
          background: @color;
          color: rgb(247, 244, 244);
          border-radius: 5px;
          font-size: 12px;
        }
      }

      h3 {
        height: 32px;
        line-height: 32px;

        //   border: 1px solid #000;
        i {
          color: @color;
          font-size: 15px;
        }

        span {
          margin: 0px 8px;
          font-size: 13.5px;
        }

        img {
          margin-left: 10px;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          vertical-align: middle;
        }
      }
    }

    .qr-code {
      padding-top: 15px;
      text-align: center;
      width: 200px;

      .qrcode {
        height: 200px;
        width: 200px;
      }

      h5 {
        margin-top: 5px;
        text-align: center;
        font-size: 15px;
        color: @color;
      }
    }
  }

  .tab-tpl-detail {
    //吸顶
    // position: sticky;
    // top: 0px;
    margin-top: 15px;
    // padding: 10px 20px;
    background-color: #fff;
    padding: 12px;

    span {
      font-size: 14px;
      margin-left: 20px;
      cursor: pointer;
      padding: 6px 8px;
    }

    span:hover {
      color: @color;
      border-bottom: 2px solid @color;
    }

    .active {
      color: @color;
      border-bottom: 2px solid @color;
    }
  }

  #scroll-content {
    margin-top: 15px;
    border: 1px solid #eee;
    height: 700px;
    overflow-y: scroll;
  }

  //活动描述
  #href-detail {
    border: 1px solid #fff;

    .act-content {
      width: 100%;
      text-indent: 30px;
      font-size: 14px;
      padding-left: 10px;
      line-height: 25px;
      letter-spacing: 0.5px;
      word-break: break-all;
    }
  }

  #href-link {
    //环节
    ul {
      padding-left: 10px;

      li {
        padding: 8px;
        padding-left: 15px;
        background-color: #f1f1f1;
        border-radius: 5px;
        cursor: pointer;
        margin-bottom: 15px;

        span {
          margin-top: 2px;
          border: 2px solid @color;
          color: @color;
          height: 30px;
          width: 30px;
          font-size: 20px;
          border-radius: 50%;
          text-align: center;
          line-height: 25px;
        }

        h1 {
          font-size: 15px;
          padding-left: 10px;
        }

        h2 {
          margin-top: 2px;
          font-size: 12px;
          padding-left: 10px;
          color: @hui;

          i {
            color: @color;
          }
        }
      }
    }
  }

  #href-result {
    ul {
      padding-left: 8px;
      // border: 1px solid rgb(241, 237, 237);
      // max-height: 357px;
      min-height: 40px;

      // overflow-y: auto;
      li {
        padding: 8px;
        margin-bottom: 15px;
        border: 1px solid rgb(224, 222, 222);
        border-radius: 5px;

        .big-icon {
          font-size: 35px;
          color: @color;
          // font-weight: 700;
        }

        .divider {
          margin-left: 20px;
          // border: 0.3px solid rgb(226, 220, 220);
          height: 38px;
        }

        h1 {
          font-size: 13px;
          padding-left: 10px;
        }

        h2 {
          margin-top: 2px;
          font-size: 12px;
          padding-left: 10px;
          color: @hui;
        }

        .look {
          margin-right: 60px;
        }

        .dow {
          margin-right: 100px;
        }

        .del {
          margin-right: 60px;
        }
      }
    }
  }

  #href-sucai {
    .big-sucai {
      // max-height: 440px;
      min-height: 40px;

      // overflow-y: auto;
      .sucai-box {
        width: 250px;
        margin-right: 20px;
        margin-top: 20px;
        position: relative;
        left: 0px;
        top: 0px;

        .del-sc {
          position: absolute;
          right: 10px;
          top: 10px;
          border: 1px solid rgba(146, 145, 145, 0);
          z-index: 20;
          color: rgba(216, 213, 213, 0);
          font-size: 20px;
          background: none;
          padding: 5px;
        }

        img {
          width: 100%;
          height: 148px;
        }

        video {
          width: 100%;
          height: 148px;
        }

        h1 {
          margin-top: 5px;
          text-align: center;
          font-size: 15px;
          padding-left: 10px;
        }

        h2 {
          text-align: center;
          margin-top: 2px;
          font-size: 12px;
          padding-left: 10px;
          color: @hui;
        }
      }

      .sucai-box:hover {
        .del-sc {
          color: rgb(247, 118, 118);
        }
      }
    }
  }
}
</style>
